import React from "react";
import { Skeleton } from "@mui/material";
// import { PiMicrophoneStage, IoTimeOutline, GrCirclePlay } from "your-icons-library";
// icons
import { PiMicrophoneStage } from "react-icons/pi";
import { GrCirclePlay } from "react-icons/gr";
import { IoTimeOutline } from "react-icons/io5";

const MusicSongLoading = () => {
  const skeletonStyles = {
    backgroundColor: "white",
    color: "white", // Set the text color to white
  };

  const skeletonItems = Array.from({ length: 10 }, (_, index) => (
    <div className="flex space-x-4 my-10 border-b-black" key={index}>
      <div className="flex-none w-16">
        <Skeleton
          variant="rectangular"
          className="rounded-lg"
          width={64}
          height={64}
          sx={{ ...skeletonStyles }}
        />
      </div>
      <div className="grow truncate">
        <Skeleton
          variant="text"
          className="ml-1"
          width={130}
          height={20}
          sx={{ ...skeletonStyles }}
        />
        <div className="mt-2">
          <Skeleton
            variant="text"
            className="ml-1"
            width={130}
            height={14}
            sx={{ ...skeletonStyles }}
          />
          {/* <div className="mx-2 inline">
            <Skeleton variant="text" className="ml-3" width={50} height={14} sx={{...skeletonStyles}} />
          </div> */}
        </div>
      </div>
      <div className="flex-none w-16 flex items-center justify-center">
        <Skeleton
          variant="circle"
          className="rounded-full"
          width={40}
          height={40}
          sx={{ ...skeletonStyles }}
        />
      </div>
    </div>
  ));

  return (
    <>
    {skeletonItems}
    </>
  );
};

export default MusicSongLoading;
